import { render, staticRenderFns } from "./PrinterConfigButton.vue?vue&type=template&id=512571f3&scoped=true"
import script from "./PrinterConfigButton.vue?vue&type=script&lang=js"
export * from "./PrinterConfigButton.vue?vue&type=script&lang=js"
import style0 from "./PrinterConfigButton.vue?vue&type=style&index=0&id=512571f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512571f3",
  null
  
)

export default component.exports